import { render, staticRenderFns } from "./LitterStatusDropdown.vue?vue&type=template&id=e1264fb6"
import script from "./LitterStatusDropdown.vue?vue&type=script&lang=ts"
export * from "./LitterStatusDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports